import React from 'react';
import styled from 'styled-components';
import { border1 } from 'utils/style/colors';

const PillSpan = styled.span`
  color: #051527;
  border: ${border1};
  border-radius: 1em;
  font-size: 11px;
  padding: 0 0.5em;
  margin: 0 0.5em;
  line-height: 1.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  text-align: center;
  display: block;
  &:hover {
    width: auto;
    min-width: 5em;
    text-overflow: initial;
  }
`;

export interface IPillProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  children: React.ReactNode;
  onClick?: () => void;
}

const Pill: React.FC<IPillProps> = ({ children, onClick }) => (
  <PillSpan onClick={onClick}>{children}</PillSpan>
);

export default React.memo(Pill);
